import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DetailOffreComponent } from './../detail-offre/detail-offre.component';
import { CommonService } from 'src/app/services/common.service';
import { CommonMessageService } from './../../../services/common-message.service';
import { PostulerComponent } from '../postuler/postuler.component';
import { Router } from '@angular/router';
import { Component, OnInit, Input } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { UserService } from 'src/app/services/user.service';
import { LoginComponent } from '../login/login.component';

@Component({
  selector: 'app-offre-list',
  templateUrl: './offre-list.component.html',
  styleUrls: ['./offre-list.component.scss'],
})
export class OffreListComponent implements OnInit {
  @Input() offres;
  findForm: FormGroup;
  constructor(
    private fb: FormBuilder,
    private user: UserService,
    private router: Router,
    private commonService: CommonService,
    private commonMessager: CommonMessageService,
    private modalController: ModalController,
    private navCtr: NavController
  ) { }

  ngOnInit() {
    this.buildLoginForm();
  }

  private buildLoginForm() {
    this.findForm = this.fb.group({
      'valeur': ['', [Validators.required]]
    });
  }
  // seeDetail(row: any) {
  //   console.log('seeDetail');
  //   this.router.navigateByUrl('/detail-offre?id=' + row.idOffre);
  // }
  seeOffre(offre, event?: CustomEvent) {
    if (event) {
      event.stopPropagation();
    }
    this.showAddCvModal(offre);
  }

  async showAddCvModal(offre) {
    console.log('offre : ', offre);
    const modal = await this.modalController.create({
      component: DetailOffreComponent,
      componentProps: { offre },
      // cssClass: 'modal'
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
    console.log('offre :', offre);
    if (data) {
      try {
        console.log('offre : ', offre);
      } catch (error) {
        await this.commonMessager.errorToast('Erreur: ' + error);
      } finally {
      }
    }
  }

  async postuler(row: any, event?: CustomEvent) {
    if (event) {
      event.stopPropagation();
    }
    let modal: HTMLIonModalElement;
    if (!this.user.currentUser) {
      // not connected
      modal = await this.modalController.create({
        component: LoginComponent
      });
      await modal.present();
      return;
    }
    const cvs = await this.hasCv();
    if (!(cvs && cvs.length > 0)) {
      this.navCtr.navigateForward('/my-cvs?addCv=1');
      return;
    }

    modal = await this.modalController.create({
      component: PostulerComponent,
      componentProps: {
        offre: row,
        cvs
      }
    });
    await modal.present();
    return;
  }
  private async hasCv() {
    const loading = await this.commonMessager.loading('Patientez un instant');
    try {
      const cvs = (await this.commonService.cvs(this.user.currentUser.idPostulant).toPromise()) as any;
      return cvs;
    } catch (error) {
      return null;
    } finally {
      loading.dismiss();
    }
  }
  async lastOffresList() {
  }

  async find() {
    this.offres = <any>await this.commonService.findOffres(this.findForm.value.valeur).toPromise();
  }
}
